package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.LabelDemo

@Page
@Composable
fun LabelPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/label.md", mapOf("title" to listOf("Label"), "description" to listOf("Renders an accessible label associated with controls."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/label"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/label#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import shadcn.ui.components.Checkbox
import shadcn.ui.components.Label
import web.cssom.ClassName

val LabelDemo = FC<Props> {
    div {
        div {
            className = ClassName("flex items-center space-x-2")
            Checkbox { id = "terms" }
            Label {
                htmlFor = "terms"
                + "Accept terms and conditions"
            }
        }
    }
}"""){ 
 LabelDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Label
""", lang= "kotlin", highlight= "")
            CodeBlock("""Label {
    htmlFor="email"
    + "Your email address"
}
""", lang= "kotlin", highlight= "")
        }
    }
}
